// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"e7","bottomColumnWapper":"e7","bottom-column-panel":"e8","bottomColumnPanel":"e8"};